module.exports = __webpack_public_path__ + "img/image11.1f1d2be1.png";